module.exports = __webpack_public_path__ + "img/people6.ba3c7dd6.png";